import React from 'react';

import * as Plotly from 'plotly.js';

class Graph extends React.Component {

    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    render() {
        return (
            <div ref={this.chartRef}></div>
        );
    }

    getPlotLayout(threshold) {
        const thr = threshold > 100 ? 100 : (threshold < 0 ? 0 : threshold);
        return {
            paper_bgcolor: '#00000000',
            plot_bgcolor: '#00000000',
            showlegend: false,
            xaxis: {
                showgrid: false,
                showticklabels: false
            },
            yaxis: {
                color: 'white',
                tickwidth: 100,
                tickcolor: 'transparent',
                showgrid: false,
                fixedrange: true,
                range: [0, 100]
            },
            margin: {
                b: 50,
                t: 50,
                r: 50,
                l: 50
            },
            shapes: [
                {
                    type: 'line',
                    xref: 'paper',
                    x0: 0,
                    y0: thr,
                    x1: 1,
                    y1: thr,
                    line: {
                        color: 'orange',
                        width: 2,
                    },
                }
            ]
        }
    }

    getPointsStartIndex() {
        return Math.max(0, this.props.xValues.length - 20)
    }

    getXVals() {

        console.log('start', this.getPointsStartIndex())

        return this.props.xValues.slice(this.getPointsStartIndex()).map((_, i) => i)
    }

    getYVals(){
        return this.props.yValues.slice(this.getPointsStartIndex()).map((obj, _) => obj)
    }

    async onShapeMoved(eventData) {
        const line = {
            x: this.getXVals(),
            y: this.getYVals(),
            mode: 'markers',
            marker: {
                color: 'white'
            }
        };
        if ('shapes[0].y0' in eventData) {
            const tresh = eventData['shapes[0].y0'];

            this.props.onThresholdChange(tresh)
            const plot = await Plotly.newPlot(this.chartRef.current, [line], this.getPlotLayout(tresh), {
                displayModeBar: false, edits: {
                    shapePosition: true
                }
            });
            plot.on('plotly_relayout', this.onShapeMoved.bind(this));
        }
    }

    async componentDidMount() {
        if (this.chartRef.current) {
            const line = {
                x: this.getXVals(),
                y: this.getYVals(),
                mode: 'markers',
                marker: {
                    color: 'white'
                }
            };
            let plot = await Plotly.newPlot(this.chartRef.current, [line], this.getPlotLayout(this.props.threshold), {
                displayModeBar: false, edits: {
                    shapePosition: true
                }
            });

            plot.on('plotly_relayout', this.onShapeMoved.bind(this));
            // setInterval(() => {
            //     Plotly.extendTraces(this.chartRef.current, {
            //         x: [[x++]],
            //         y: [[Math.random() * 100]]
            //     }, [0], 20);
            // }, 1000);
        }
    }

    async componentDidUpdate()  {
        this.componentDidMount()
    }
}


export default Graph;